import { observable } from "mobx";
import { api, api_adm, apiOperacao } from "../../api";
import { toast } from "react-toastify";
import { toast_error } from "../../utils";

export class _BotsStore {

  obs = observable({
    tabelaBots: [] as any,
    currentPageBot: 1 as number,
    length_bots: 0 as number
  })

  /**
   * Busca a lista de bots (tarefas) com base nos parâmetros de filtro fornecidos.
   * 
   * A função executa as seguintes ações:
   * 1. Envia uma requisição `POST` para o endpoint `/api/bots/index` com os parâmetros especificados.
   * 2. Inicializa a lista de bots (`this.obs.tabelaBots`) e o contador (`this.obs.length_bots`) como vazios/zerados.
   * 3. Caso a resposta da API contenha itens:
   *    - Atribui os itens retornados a `this.obs.tabelaBots`.
   *    - Atualiza `this.obs.length_bots` com o total de registros retornados (`resp.data.count`).
   * 4. Se ocorrer qualquer erro durante a requisição, exibe uma notificação de erro ao usuário.
   * 
   * Essa função é geralmente chamada por ações de busca, paginação ou filtro na interface.
   * 
   * @param {Object} params Objeto contendo os filtros e dados necessários para a busca (ex: tipo, status, datas, etc.).
   * 
   * @returns {Promise<void>} Não retorna valor diretamente, mas atualiza os observáveis com os dados retornados da API.
  */

  async handleGetBots(params) {
    try {
      let resp = await apiOperacao("bots").post(`/bots/index`, params);

      this.obs.tabelaBots = [];
      this.obs.length_bots = 0;

      if (resp.data.itens.length > 0) {

        this.obs.tabelaBots = resp.data.itens
        this.obs.length_bots = resp.data.count

      }

    } catch (ex) {
      toast_error(ex, `Erro ao carregar tarefas, tente novamente mais tarde.`);
    }
  }

  /**
   * Reinicia uma ou mais tarefas (bots) com base nos itens informados.
   * 
   * A função executa as seguintes ações:
   * 1. Envia uma requisição `POST` para o endpoint `/api/bots/restart` com os itens a serem reiniciados, contidos em `params`.
   * 2. Se a resposta retornar uma lista vazia (`resp.data.length === 0`) e houver itens enviados para reinício, exibe uma mensagem de sucesso ao usuário indicando que as tarefas foram reiniciadas.
   * 3. Retorna os dados da resposta (`resp.data`), que podem conter informações sobre erros ocorridos durante o processo.
   * 4. Em caso de erro na requisição, exibe uma mensagem de erro ao usuário e retorna um array vazio.
   * 
   * Essa função é geralmente utilizada para reiniciar tarefas com falha ou com status pendente, acionada a partir de uma ação do usuário na interface.
   * 
   * @param {Object} params Objeto contendo os itens (`params.itens`) que devem ser reiniciados.
   * 
   * @returns {Promise<Array>} Retorna um array com os resultados da reinicialização. Pode conter erros ou estar vazio se a operação for bem-sucedida.
  */

  async handleRestartBots(params) {

    try {

      let resp = await apiOperacao("bots").post(`/bots/restart`, params);

      if (resp.data.length == 0 && params.itens.length > 0) {

        toast.success("Reiniciada a(s) tarefa(s)!", {});

      }

      return resp.data

    } catch (ex) {
      toast_error(ex, `Erro ao reiniciar tarefa(s), tente novamente mais tarde.`);
    }

    return []

  }

}

export const BotsStore = new _BotsStore();
